import React from 'react';
import PropTypes from 'prop-types';

import AppsItem from './AppsItem';

import { msg } from 'api';

const msgs = msg.footers.footer;

const Apps = ({ appLinks }) => (
  <div className="ft-apps">
    <p className="ft-apps__title">{msgs.appsLinkText}</p>
    <ul className="ft-apps__list">
      {appLinks.map(link => (
        <AppsItem
          id={link.id}
          key={link.id}
          title={link.title}
          url={link.url}
        />
      ))}
    </ul>
  </div>
);

Apps.propTypes = {
  appLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ),
};

export default Apps;
